
import { FC } from 'react'
import { Auth } from 'aws-amplify'
import { useHistory } from 'react-router-dom'
import { Alert } from 'react-bootstrap-v5'

const NoJobfairSelected: FC = () => {
    const history = useHistory()

    const handleLogout = async () => {
        try {
            await Auth.signOut()
            history.push('/auth')
        } catch (error) {
            console.error('Error signing out:', error)
        }
    }

    return (
        <div className='card d-flex justify-content-center align-items-center min-h-500px'>
            <div className='card-body p-10'>
                <Alert
                    color='danger'
                    title='No Job Fair Selected'
                    className='mb-5 border border-dashed border-danger p-7'
                >
                    <div className='fw-bold fs-4 mb-5 text-center'>
                        You have not selected any job fair to participate in.
                    </div>
                    <div className='fs-6 mb-5 text-center'>
                        Please use the registration link provided by your Job Fair Manager or Recruiter to access
                        the specific job fair event.
                    </div>
                    <div className='d-flex justify-content-center'>
                        <button
                            type='button'
                            className='btn btn-danger px-8'
                            onClick={handleLogout}
                        >
                            <i className='fas fa-sign-out-alt me-2'></i>
                            Logout
                        </button>
                    </div>
                </Alert>
            </div>
        </div>
    )
}

export default NoJobfairSelected
